<div class="wrapper">

<div class="responsive-container content">
<nav>
  <div>
  <img class="weterynarz-logo" src="assets/weterynarz-mogilany-logo-gabinet.png">
  </div>
  <div class="logo">Weterynarz Mogilany</div>
  <ul class="menu">
    <li>
      <a class="pill" routerLink="/home" routerLinkActive="active" ariaCurrentWhenActive="page">Home</a>
    </li>
    <li>
    <a class="pill" routerLink="/kontakt" routerLinkActive="active" ariaCurrentWhenActive="page">Kontakt</a>
    </li>
  </ul>
</nav>

<main>
  <router-outlet></router-outlet>
</main>

</div>
<!--
<footer class="footer">
  <ul>
    <li>2025 Weterynarz Mogilany</li>
  </ul>
  <ul class="ulleft">
    <li><a href="http://www.sibrica.com">Powered by Sibrica</a></li>
  </ul>
</footer>
-->

</div>
